<template>
  <v-dialog :value="value" max-width="560" @input="$emit('input', $event)">
    <v-card v-if="value">
      <v-card-title>{{ $t('firmware.other.title') }}</v-card-title>
      <v-card-subtitle>{{ $t('firmware.other.explained', {version: currentVersion || '-'}) }}</v-card-subtitle>
      <v-card-text>
        <div v-if="!versions.length" class="text--secondary">{{ $t('firmware.other.none') }}</div>
        <v-radio-group v-else v-model="versionId" class="mt-0">
          <v-radio v-for="version in versions" :key="version.id" :value="version.id" :disabled="!selectable(version)">
            <template #label>
              <div>
                <span class="mono font-weight-medium">{{ version.name }}</span>
                <v-chip v-if="!version.version" x-small outlined color="orange" class="ml-2">{{ $t('manufacturer.sheet.version-pending') }}</v-chip>
                <v-chip x-small class="ml-2" :color="firmwareStatusColor(version.status)" text-color="white">{{ $t('firmware.firmware-statuses.' + version.status) }}</v-chip>
                <div class="text-caption text--secondary">
                  <template v-if="version.problem">{{ $t('firmware.path.' + version.problem) }}</template>
                  <template v-else-if="version.steps.length > 1">{{ $t('firmware.via', {steps: version.steps.slice(0, -1).join(' → ')}) }}</template>
                  <template v-else>{{ $t('firmware.other.direct') }}</template>
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-alert v-if="chosen && chosen.status === 'testing'" type="warning" text dense>{{ $t('firmware.other.forced') }}</v-alert>
        <v-textarea v-if="chosen" v-model="reason" :label="$t('firmware.other.reason')" rows="2" auto-grow outlined dense />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small text @click="$emit('input', false)">{{ $t('cancel') }}</v-btn>
        <v-btn small color="primary" :disabled="!chosen" :loading="sending" @click="send">{{ $t('firmware.other.send') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FirmwareRepository from "@repository/FirmwareRepository";
import FirmwareMixin from "@pages/Firmware/FirmwareMixin";

/**
 * Envoyer à une borne un autre firmware que celui conseillé : un validé, ou un en test (forcé, droit dédié). Chaque
 * firmware montre son chemin depuis la version de la borne ; sans chemin, il ne se choisit pas.
 */
export default {
  mixins: [FirmwareMixin],

  props: {
    value: {type: Boolean, default: false},
    chargingPointId: {type: String, required: true},
    currentVersion: {type: String, default: null},
    versions: {type: Array, default: () => []},
    // Coché à l'ouverture (« Revenir à la version d'avant »).
    initialVersionId: {type: String, default: null},
  },

  data() {
    return {
      versionId: null,
      reason: '',
      sending: false,
    }
  },

  computed: {
    chosen() {
      return this.versions.find(version => version.id === this.versionId) || null
    },
  },

  watch: {
    value(open) {
      if (open) {
        this.versionId = this.initialVersionId
        this.reason = ''
      }
    },
  },

  methods: {
    selectable(version) {
      return !version.problem && (version.status !== 'testing' || this.canForceFirmware)
    },

    send() {
      this.sending = true
      FirmwareRepository.startUpdate(this.chargingPointId, this.versionId, this.reason.trim() || null).then(() => {
        this.$emit('input', false)
        this.$emit('sent')
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.sending = false
      })
    },
  },
}
</script>

<style scoped>
.mono {
  font-family: ui-monospace, monospace;
}
</style>
